import { ExternalLink } from 'lucide-react'
import type { components } from '@/api/schema'
import { poTrackingNumbers } from './tracking-number-links'

type Shipment = components['schemas']['PurchaseOrderDetailShipmentRead']

export function POTrackingNumbers({ shipments }: { shipments: Shipment[] }) {
  const numbers = poTrackingNumbers(shipments)
  if (numbers.length === 0) return null
  return (
    <ul
      aria-label="Tracking numbers"
      className="flex flex-wrap gap-x-4 gap-y-1 text-xs lg:justify-end"
    >
      {numbers.map((item) => (
        <li key={item.key} className="flex min-w-0 items-baseline gap-1.5">
          {item.carrier && <span className="text-muted-foreground">{item.carrier}</span>}
          {item.isPro && <span className="text-muted-foreground">PRO</span>}
          {item.url ? (
            // eslint-disable-next-line no-restricted-syntax -- external URL
            <a
              href={item.url}
              target="_blank"
              rel="noopener noreferrer"
              title={`Track on ${item.carrier ?? 'the carrier site'}`}
              className="inline-flex items-center gap-1 rounded-sm font-mono font-medium text-foreground underline decoration-foreground/30 underline-offset-4 hover:decoration-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/50"
            >
              {item.number}
              <ExternalLink className="size-3 shrink-0 text-muted-foreground" aria-hidden="true" />
              <span className="sr-only">(opens carrier tracking)</span>
            </a>
          ) : (
            <span className="font-mono font-medium">{item.number}</span>
          )}
        </li>
      ))}
    </ul>
  )
}
